import { FC } from 'react';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { IonButton } from '@ionic/react';

export const ResourcesCard: FC = () => {
    return (
        <Card padded>
            <div style={{marginBottom: 12}}>
                <Text><b>Caregiver Resources</b></Text>
            </div>

            <p>
                Find Innerhive-curated resources: Community Support Groups, Services, and much more!
            </p>

            <div style={{margin: '0 auto 30px', maxWidth: 200, textAlign: 'center'}}>
                <IonButton expand="block" href="https://www.innerhive.com/caregiver-resources/all-resources" target="_blank">
                    Find Resources
                </IonButton>
            </div>
        </Card>
    );
};
